import { generateClient } from 'aws-amplify/api';
import { deleteNotification } from "../graphql/mutations";

const client = generateClient();

export default async ({ id, userId, hasViewed, status, content, date, expiry }) => {
    try {
        const {
            data: { deleteNotification: deletedNotification },
        } = await client.graphql({
            query: deleteNotification,
            variables: {
                input: {
                    id,
                    userId,
                    hasViewed,
                    status,
                    content,
                    date,
                    expiry
                },
            },
        });
        return deletedNotification;
    } catch (ex) {
        console.error("Failed to clear notification", ex);
    }
};